<h4>Move document</h4>
<p class="mb-5 text-gray-600">
	Select a folder to move "<span
		class="font-bold"
		[innerHtml]="data.document.title"
	></span
	>"
</p>

<div>
	<ul>
		<li class="py0.5">
			<div class="flex w-full border-b border-gray-200 py-2 items-center">
				<input
					type="radio"
					name="selectedFolder"
					id="rootFolder"
					[(ngModel)]="currentFolderId"
					value=""
					class="m-2 ml-0"
				/>
				<label for="rootFolder">
					<app-icon
						*ngIf="!oldFolderId"
						icon="folderOpen"
						class="text-gray-600 mr-3 text-2xl"
					></app-icon>
					<app-icon
						*ngIf="oldFolderId"
						icon="folder"
						class="text-gray-600 mr-3 text-2xl"
					></app-icon>
					Root
				</label>
			</div>
			<ul class="ml-4">
				<ng-container
					*ngTemplateOutlet="folderList; context: { currentId: '' }"
				></ng-container>
			</ul>
		</li>
	</ul>
</div>

<div class="flex justify-between mt-10">
	<app-button btn="tertiary" class="mr-5" (click)="cancelModal()" size="small"
		>Cancel</app-button
	>
	<app-button size="small" (click)="moveDocument()">Move here</app-button>
</div>

<ng-template let-currentId="currentId" #folderList>
	<ng-container *ngFor="let folder of folders">
		<li *ngIf="folder.parentId === currentId" class="py-0.5">
			<div class="flex w-full border-b border-gray-200 py-2 items-center">
				<input
					type="radio"
					name="selectedFolder"
					[id]="folder.id"
					[(ngModel)]="currentFolderId"
					[value]="folder.id"
					class="m-2 ml-0"
				/>
				<label [for]="folder.id">
					<app-icon
						*ngIf="oldFolderId === folder.id"
						icon="folderOpen"
						class="text-gray-600 mr-3 text-2xl"
					></app-icon>
					<app-icon
						*ngIf="oldFolderId !== folder.id"
						icon="folder"
						class="text-gray-600 mr-3 text-2xl"
					></app-icon>
					<span [innerHtml]="folder.title"></span>
				</label>
			</div>
			<ul *ngIf="folder.children" class="ml-4">
				<ng-container
					*ngTemplateOutlet="folderList; context: { currentId: folder.id }"
				></ng-container>
			</ul>
		</li>
	</ng-container>
</ng-template>
